
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Die Grafik zeigt, wann Länder den Pfad des exponentiellen Wachstums bei den
bestätigten Covid-19-Fallzahlen verlassen haben. Der Trick: Neue Fälle werden
den kumulierten in einer doppelten logarithmischen Skala gegenübergestellt.
Nationen, in denen die Entwicklung entlang der gestrichelten, diagonalen Schräge
verläuft, sind mit exponentiellem Tempo unterwegs. Der Vergleich der Entwicklung
der Fallzahlen lässt sich visuell am deutlichsten zeigen, wenn man sie auf einer
logarithmischen Achse darstellt. Auf solch einer Skala wird nicht der Zahlenwert
einer Grösse abgetragen, sondern der Logarithmus desselben. Die Y-Achse – und in
diesem speziellen Fall auch die X-Achse – wird gestaucht und ermöglicht es,
grössere Wertebereiche übersichtlich darzustellen. `}<strong parentName="p">{`Angezeigt werden alle
Länder mit über 5000 bestätigten Fällen, die Mitglieder der Gruppe sind jeweils
farblich hervorgehoben.`}</strong></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;